
const channelsForUser = (allChannels, obj) => {
    const result = allChannels.filter((channel) => {
        return (obj.userPrivilege?.channel_ids?.includes(channel.id) && channel.channel_type !== 'location_feed');
    });
    return result;
}

const otherChannelsUserIsNotPartOf = (allChannels, obj) => {
    const result = allChannels.filter((channel) => {
        return (obj.userPrivilege?.channel_ids?.includes(channel.id) == false && channel.channel_type !== 'location_feed');
    });
    return result;
}

const rolesForUser = (allRoles, obj) => {
    const result = allRoles.filter((role) => {
        return (obj.userPrivilege?.user?.tag_ids?.includes(role.id));
    });
    return result;
}

const otherRolesUserIsNotPartOf = (allRoles, obj) => {
    const result = allRoles.filter((role) => {
        return (obj.userPrivilege?.user?.tag_ids?.includes(role.id) == false);
    });
    return result;
}

export default {
    channelsForUser,
    otherChannelsUserIsNotPartOf,
    rolesForUser,
    otherRolesUserIsNotPartOf,
}